<script lang="ts">
    // Bloco de rótulo discreto — hoje é o Zblock na densidade "rotulo". Continua existindo com este
    // nome e esta API porque as folhas do mobile e as telas modernizadas o chamam assim; o desenho
    // do cartão mora no z/zblock.svelte, junto com o do Zframe e o do Zgrid2.
    import Zblock from '../zblock.svelte'

    let className: string = ''
    export { className as class }
    export let label: string = ''
    /** texto pequeno à direita do rótulo (ex.: "1 item · 1h", "obrigatório") */
    export let meta: string = ''
    export let tone: 'default' | 'danger' | 'attention' = 'default'
    export let collapsible: boolean = false
    export let open: boolean = true
    /** tira o espaçamento interno (para listas que desenham as próprias linhas até a borda) */
    export let flush: boolean = false
</script>

<Zblock densidade="rotulo" class="zsection {className}" title={label} {meta} {tone} {collapsible} bind:open {flush} on:toggle>
    <svelte:fragment slot="acts"><slot name="acts" /></svelte:fragment>
    <slot />
</Zblock>
